
import { defineComponent } from "vue";
import Container from "../../components/Structure/Container.vue";
import { Header, Textarea, QuestionWrapper } from "../../components/Questions";
import { useRouter } from "vue-router";

export default defineComponent({
  components: {
    Container,
    Header,
    Textarea,
    QuestionWrapper,
  },
  setup() {
    const questionNumber = 11;
    const router = useRouter();
    const title =
      "Have you ever had a reaction/side effects to birth control? Please list the birth control(s) and what happens when you use it.";
    const subtitle = "Submit N/A if not applicable.";

    const onAnswered = () => {
      router.push(String(questionNumber + 1));
    };

    return {
      onAnswered,
      title,
      subtitle,
      questionNumber,
    };
  },
});
